export default {
  api: {
    host: 'https://maps.trimet.org/otp_mod',
    paths: {
      plan: '/plan',
    },
  },
  otp2api: {
    host: 'https://ws-st.trimet.org/rtp/routers/default',
    paths: {
      plan: '/plan',
    },
  },
};
